/**
 * Formateo de precios. Sin dependencias, importable desde Node y desde React.
 *
 * Regla de negocio:
 *  - Facturación Electrónica (e-CF) SIEMPRE en DOP (RD$990, RD$1,990).
 *  - Productos SaaS propios en USD (salvo los de facturación electrónica: ERP con FE y POS con FE → DOP).
 *  - Servicios de desarrollo: DOP en el mercado RD, USD en /latam y /us.
 */
export const formatPrice = (amount, currency = 'DOP', locale = 'es-DO') =>
    new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        maximumFractionDigits: 0,
    }).format(amount);

/**
 * Resuelve el importe de un tier para una moneda concreta.
 * `from` puede ser: número (en la moneda base del pricing), objeto { DOP, USD } o null.
 * Devuelve número o null si no hay precio publicado para esa moneda.
 */
export const resolveAmount = (from, currency, baseCurrency) => {
    if (from == null) return null;
    if (typeof from === 'number') return currency === baseCurrency ? from : null;
    if (typeof from === 'object') return from[currency] ?? null;
    return null;
};
